if (!window.mjCartPromoBound) {
  window.mjCartPromoBound = true;

  document.addEventListener('click', (event) => {
    const applyButton = event.target.closest('[data-mj-cart-promo-apply]');
    if (!applyButton) return;
    event.preventDefault();
    applyMjCartDiscount(applyButton);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest('[data-mj-cart-promo-input]');
    if (!input) return;
    event.preventDefault();
    const root = input.closest('[data-mj-cart-promo]');
    const applyButton = root && root.querySelector('[data-mj-cart-promo-apply]');
    if (applyButton) applyMjCartDiscount(applyButton);
  });
}

function showMjCartPromoMessage(applicable, alreadyApplied) {
  const root = document.querySelector('[data-mj-cart-promo]');
  const message = root && root.querySelector('[data-mj-cart-promo-message]');
  const button = root && root.querySelector('[data-mj-cart-promo-apply]');
  if (!root || !message || !button) return;

  root.open = true;
  message.hidden = false;
  message.classList.remove('is-error', 'is-success');

  if (alreadyApplied) {
    message.textContent = button.dataset.applied || button.dataset.success || '';
    message.classList.add('is-success');
    return;
  }

  if (applicable) {
    message.textContent = button.dataset.success || '';
    message.classList.add('is-success');
    return;
  }

  message.textContent = button.dataset.error || '';
  message.classList.add('is-error');
}

async function refreshMjCartDrawer() {
  const cartUrl = window.routes && window.routes.cart_url;
  if (!cartUrl) return;

  const response = await fetch(`${cartUrl}?section_id=cart-drawer`);
  const responseText = await response.text();
  const html = new DOMParser().parseFromString(responseText, 'text/html');
  const source = html.querySelector('.drawer__inner');
  const target = document.querySelector('cart-drawer .drawer__inner');
  if (source && target) target.replaceWith(source);

  const overlay = document.querySelector('#CartDrawer-Overlay');
  const drawer = document.querySelector('cart-drawer');
  if (overlay && drawer) {
    overlay.addEventListener('click', drawer.close.bind(drawer));
  }
}

async function applyMjCartDiscount(button) {
  const root = button.closest('[data-mj-cart-promo]');
  const input = root && root.querySelector('[data-mj-cart-promo-input]');
  const message = root && root.querySelector('[data-mj-cart-promo-message]');
  const code = input && input.value && input.value.trim();
  const updateUrl = window.routes && window.routes.cart_update_url;
  const cartUrl = window.routes && window.routes.cart_url;

  if (!code) {
    if (message) {
      message.hidden = false;
      message.textContent = button.dataset.error || '';
      message.classList.remove('is-success');
      message.classList.add('is-error');
    }
    return;
  }

  if (!updateUrl || !cartUrl) return;

  button.disabled = true;
  if (message) {
    message.hidden = true;
    message.textContent = '';
    message.classList.remove('is-error', 'is-success');
  }

  try {
    const cartResponse = await fetch(`${cartUrl}.js`);
    const cart = await cartResponse.json();
    const existingCodes = (cart.discount_codes || [])
      .filter((entry) => entry.applicable && entry.code)
      .map((entry) => entry.code);
    const alreadyApplied = existingCodes.some(
      (entry) => entry.toLowerCase() === code.toLowerCase()
    );

    if (alreadyApplied) {
      showMjCartPromoMessage(true, true);
      return;
    }

    const discount = existingCodes.length ? `${existingCodes.join(',')},${code}` : code;
    const response = await fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        discount,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    const codes = data.discount_codes || [];
    const matched = codes.find(
      (entry) => entry.code && entry.code.toLowerCase() === code.toLowerCase()
    );
    const applicable = Boolean(matched && matched.applicable);

    const drawer = document.querySelector('cart-drawer');
    if (drawer && data.sections && data.sections['cart-drawer']) {
      drawer.renderContents({
        sections: data.sections,
        id: data.items && data.items[0] && (data.items[0].variant_id || data.items[0].id),
      });
    } else {
      await refreshMjCartDrawer();
    }

    showMjCartPromoMessage(applicable, false);
  } catch (error) {
    showMjCartPromoMessage(false, false);
  } finally {
    const nextButton = document.querySelector('[data-mj-cart-promo-apply]');
    if (nextButton) nextButton.disabled = false;
    else button.disabled = false;
  }
}
